export class RoleStreamFilters {
    vet: boolean;
    vetNurse: boolean;
    nonClinical: boolean;
    practiceContent: boolean;

    constructor(roleStreamFilters?) {
        if (roleStreamFilters) {
            this.vet = roleStreamFilters.id || false;
            this.vetNurse = roleStreamFilters.name || false;
            this.nonClinical = roleStreamFilters.id || false;
            this.practiceContent = roleStreamFilters.name || false;
        }
    }
}
